import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import BaseSaveModel from "../savegame/BaseSaveModel";

export default class BaseTrackResumeEventTask extends Task {
    /**
     * @constructor
     * @param {BaseSaveModel} saveModel
     */
    constructor(saveModel) {
        super();

        this._saveModel = saveModel;
    }

    execute(callback) {
        const saveGameObject = this._saveModel.getSaveGame();

        const hasSaveGame = !!saveGameObject;
        const saveGameIsCompatible = this._saveModel.saveGameIsCompatible(saveGameObject);
        const triggerResumeEvent = hasSaveGame && saveGameIsCompatible;
        if (triggerResumeEvent) {
            this.trackResumeEvent();
        }

        callback();
    };

    trackResumeEvent() {
        // Override in game specific code.
    }
}